import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=6012e299&"
import script from "./Groups.vue?vue&type=script&lang=ts&"
export * from "./Groups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports